import { AxiosApiError } from "@/lib/config/types";

/**
 * Extrai a mensagem de erro de uma resposta Axios
 * Tenta obter a mensagem do response.data.error.message, 
 * depois do error.message, e por fim usa o fallback
 */
export const getErrorMessage = (e: AxiosApiError, fallback: string): string => {
    return e?.response?.data?.error?.message || e?.message || fallback;
};
